import { GridToolbarContainer } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { TABLES } from "../../../../enums/Enums";
import QuickDownloadToolBar from "../QuickDownloadToolBar/QuickDownloadToolBar";
import QuickFilterToolBar from "../QuickFilterToolBar/QuickFilterToolBar";
import QuickSearchToolbar from "../QuickSearchToolbar/QuickSearchToolbar";
import classes from "./CustomToolbar.module.css";
import { Button } from "@mui/material";
import Icons from "../../../../resources/icons/Icons";


export const CustomToolbar = (props) => {
  const { isTableModal, toolBarTitle, toolBarSecondaryTitle, tableId, handleClose, quickDownload, quickSearch, quickFilter } = props;
  return (
    <>
      {isTableModal ? (
        <GridToolbarContainer className={classes.tableModalToolBarContainer}>
          <div className={classes.start}>
            <span className={classes.toolBarTitle}>{toolBarTitle}</span>
          </div>
          <div className={classes.end}>
            <QuickDownloadToolBar {...quickDownload}></QuickDownloadToolBar>
            <Button onClick={handleClose}>
              <img src={Icons.DELETE_ITEM_4} />
            </Button>
          </div>
        </GridToolbarContainer>
      ) : tableId === TABLES.HISTORY || tableId === TABLES.BILLING_HISTORY? (
        <GridToolbarContainer className={classes.tableModalToolBarContainer}>
          <div className={classes.start}>
            <div className={classes.titles}>
              <span className={classes.toolBarTitle}>{toolBarTitle?.title}</span>
              <span className={[classes.toolBarTitle, classes.secondary].join(' ')}>{toolBarSecondaryTitle?.title}</span>
            </div>
            <div className={[classes.titles, classes.left].join(' ')}>
              <span className={classes.toolBarTitle}>{toolBarTitle?.value}</span>
              <span className={[classes.toolBarTitle, classes.secondary].join(' ')}>{toolBarSecondaryTitle?.value}</span>
            </div>
          </div>
          <div className={classes.end}>
            <QuickDownloadToolBar {...quickDownload}></QuickDownloadToolBar>
            <QuickSearchToolbar {...quickSearch}></QuickSearchToolbar>
            <QuickFilterToolBar {...quickFilter} tableId={tableId}></QuickFilterToolBar>
          </div>
        </GridToolbarContainer>
        )
        : (
        <GridToolbarContainer className={classes.toolBarContainer}>
          {(quickDownload?.tableId == TABLES.PARKERS || quickDownload?.tableId == TABLES.GMT) && <QuickDownloadToolBar {...quickDownload}></QuickDownloadToolBar>}
          <QuickSearchToolbar {...quickSearch}></QuickSearchToolbar>
          {(quickFilter?.tableId == TABLES.GUESTS || quickFilter?.tableId == TABLES.PARKERS || 
            (TABLES.CAMPAIGNS <= quickFilter?.tableId && quickFilter?.tableId <= TABLES.MAILING_LIST)) 
            && <QuickFilterToolBar {...quickFilter}></QuickFilterToolBar>}
        </GridToolbarContainer>
      )}
    </>
  );
};

CustomToolbar.propTypes = {
  quickDownload: PropTypes.object.isRequired,
  quickSearch: PropTypes.object.isRequired,
  quickFilter: PropTypes.object.isRequired,
};
